import {
  createAttachToken,
  createBaseApi,
  createBlobApi,
} from 'shared';

import {CF_API, STUDIO_API} from '@/config';

import {mainRequest, msal} from './azure';

const attachToken = createAttachToken(msal, mainRequest);

export const api = createBaseApi(STUDIO_API, attachToken);

export const blobApi = createBlobApi(CF_API, attachToken);
